// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = (..._args: any[]): void => {};

export const capitalized = (word: string) =>
  word.charAt(0).toUpperCase() + word.slice(1);
